import Navbar from '../../components/layout/Navbar';
import HistorialAlertas from '../../components/sections/HistorialAlertas';
import Footer from '../../components/layout/Footer';

export default function HistorialAlertasPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar activeSection="historial-alertas" />

      <main className="pt-16">
        {/* Sección Historial de Alertas */}
        <section id="historial-alertas" className="py-20 bg-gradient-to-br from-slate-50 to-gray-100 min-h-screen">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-slate-800 mb-4">Historial de Alertas</h2>
              <p className="text-xl text-slate-600">Seguimiento completo y tendencias de alertas</p>
            </div>
            <HistorialAlertas />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}